angular.module('eStories.author', [

    /*Book Details Module*/
])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.author', {
                url: 'author/:authorId?pageNumber&genreId&&subGenreId&sortField&languageId&duration&abridged&onlyForCredit&onlyForFree&onlyOnSale',
                views: {
                    'mainView@': {
                        controller: 'BrowseCtrl as browseCtrl',
                        templateUrl: 'store/author/author.tmpl.html'
                    }
                }
            })
            .state('eStories.navbars.authorFull', {
                url: 'author/:authorId/:authorName?pageNumber&genreId&&subGenreId&sortField&languageId&duration&abridged&onlyForCredit&onlyForFree&onlyOnSale',
                views: {
                    'mainView@': {
                        controller: 'BrowseCtrl as browseCtrl',
                        templateUrl: 'store/author/author.tmpl.html'
                    }
                }
            });
    }])
    .filter('linkToAuthor', ['$filter', function ($filter) {
        return function (author) {
            if (!author) {
                return null;
            }

            return "/author/" + author.id + "/" + $filter('urlReadyName')(author.name);
        }
    }]);

/*ATTENTION / IMPORTANT: This module uses BrowseCtrl, located on store/browse directory */